// Clerk configuration
export const clerkConfig = {
  publishableKey: process.env.REACT_APP_CLERK_PUBLISHABLE_KEY as string,
  // Optional: Configure appearance
  appearance: {
    elements: {
      formButtonPrimary: {
        backgroundColor: '#0078d4',
        '&:hover': {
          backgroundColor: '#106ebe',
        },
      },
    },
  },
}; 